import axios from 'axios';
import { getEnvUrl } from '../helpers/getEnvUrl';

export const getContentType = () => ({ 'Content-Type': 'application/json' });

const { apiBaseUrl } = getEnvUrl();

export const instance = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    ...getContentType(),
    'x-api-key': process.env.REACT_APP_GUARD_API_KEY,
  },
});

export default instance;
